import { atom } from 'infrastructure/state/jotai.wrapper'
import { INode } from 'shared/types/tree'
import { PresentationFile } from './types'
import { getGradeId, nodesOfTypeWithContentV2 } from '../../utility/TreeHelpers'
import { objectFieldSort } from '../../../utility'
import { createIdMap } from '../../version_mapping/utility'
import { NodeType } from 'shared/types/ingestion'
import { DeleteNodeUpdateData } from '../nodeUpdates/types'
import { idsForNode, UpdateMethod, UpdateType } from '../nodeUpdates/utility'

export const updatingAtom = atom(false)

export const presentationsTreeAtom = atom<INode | null | undefined>(null)
export const presentationsTreeIdMap = atom((get) => {
  const tree = get(presentationsTreeAtom)
  if (!tree) return
  return createIdMap(tree)
})

export const nodeTitleAtom = atom('Presentations')

export const customFormatFileNameAtom = atom('{grade}.{unit}.{lesson} - {name}')

export const gDriveFolderAtom = atom('')

export const gDriveDataAtom = atom<PresentationFile[]>([])

export const gradeStringAtom = atom((get) => {
  const tree = get(presentationsTreeAtom)
  if (!tree) return
  const grade = getGradeId(tree)
  if (!grade) return
  const gradeNum = grade - 1
  return gradeNum || 'K'
})

export const gDriveFilesForTree = atom<PresentationFile[]>((get) => {
  const grade = get(gradeStringAtom)
  if (!grade) return []
  const gDriveFiles = get(gDriveDataAtom)
  return gDriveFiles
    .filter(({ name }) => name.startsWith(`${grade}.`))
    .sort(objectFieldSort('name'))
})

export const existingPresentationListsAtom = atom((get) => {
  const tree = get(presentationsTreeAtom)!

  return nodesOfTypeWithContentV2({
    tree,
    types: [NodeType.LessonPlan],
  }).reduce<INode[]>((acc, lesson) => {
    return [
      ...acc,
      ...lesson.nodes.filter(
        ({ type, title }) =>
          type === NodeType.NodeList && title.includes('Presentations'),
      ),
    ]
  }, [])
})

export const existingPresentationsDeleteParams = atom((get) => {
  const presentationLists = get(existingPresentationListsAtom)
  return presentationLists.map<DeleteNodeUpdateData>((p) => {
    return {
      type: UpdateType.node,
      method: UpdateMethod.delete,
      ids: idsForNode(p),
    }
  })
})

export const flowIdsAtom = atom<string[]>([])
